export default "__VITE_ASSET__kne3eFYH__"